import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard/Dashboard';
import QueueCreate from './QueueManagement/QueueCreate';
import QueueList from './QueueManagement/QueueList';
import QueueMonitorView from './QueueMonitor/QueueMonitor';
import CreateOrganization from './Organizations/CreateOrganization';
import OrganizationsList from './OrgnizationsList/OrganizationsList';

const DashboardHome = () => {
  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-routes">
        <Routes>
          <Route index element={<Dashboard />} />
          <Route path="queue/monitor" element={<QueueMonitorView />} />
          <Route
            path="queue/monitor/:queueId"
            element={<QueueMonitorView />}
          />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="queue/create" element={<QueueCreate />} />
          <Route path="queue/list" element={<QueueList />} />
          <Route path="*" element={<Navigate to="" replace />} />
          <Route path="createorganization" element={<CreateOrganization />} />
          <Route path="organizations-list" element={<OrganizationsList />} />
        </Routes>
      </div>
    </div>
  );
};

export default DashboardHome;
